import classNames from 'classnames';
import { FlexContainer } from 'components';
import { observer } from 'mobx-react-lite';
import { tenancyAgreementStatusTypes } from 'config/types';
import { useTenancy } from 'state';
import { ErrorStatus, AwaitingSignatures, NotCreated, Signed } from './bricks';
import styles from './TodoItemAgreement.module.scss';

/**
 * TodoItemAgreement
 *
 * @return {JSX.Element}
 */
const TodoItemAgreement = ({ className }) => {
  const tenancyDoc = useTenancy();
  const tenancyData = tenancyDoc.data;
  const status = tenancyData.agreement.status;

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemInventory,
        className,
        TodoItemAgreement.displayName
      )}
      column
      gap
    >
      {status === tenancyAgreementStatusTypes.error ? <ErrorStatus /> : null}
      {status === tenancyAgreementStatusTypes.notCreated ? (
        <NotCreated />
      ) : null}
      {status === tenancyAgreementStatusTypes.awaitingSignatures ? (
        <AwaitingSignatures />
      ) : null}
      {status === tenancyAgreementStatusTypes.signed ? <Signed /> : null}
    </FlexContainer>
  );
};

TodoItemAgreement.displayName = 'TodoItemAgreement';

export default observer(TodoItemAgreement);
